// import axios from './axios';

import axios from "./axios";

function index() {
    return axios().get("/payment-modes");
}

function create(data) {
    return axios().post("/payment-modes", data);
}

function update(data) {
    console.log(data);
    return new Promise(resolve => {
        setTimeout(() => {
            resolve({
                data: {
                    id: 1
                }
            })
        }, 500);
    });
}

function find(id) {
    console.log(id)
    return new Promise((resolve) => {
        setTimeout(() => {
            resolve({
                data: {
                    id: 1,
                    payment_type: {
                        id: 1,
                        name: "Cash"
                    },
                    ledger_account: {
                        id: 21,
                        display_name: "1231312 - Some Account Here and there for test."
                    }
                }
            })
        }, 500);
    })
}

function remove(data) {
    console.log(data)
    return new Promise((resolve) => {
        setTimeout(() => {
            resolve({
                data: {
                    id: 1
                }
            })
        }, 500);
    })
}

export default {
    find,
    create,
    update,
    remove,
    index
}